import instance from '../axios'
import { getRegion } from '../utils/region'

const moviesApi = {
    getTrending: (page: number = 1) => {
        return instance.get(`/movies/trending`, { params: { page } })
    },

    getPopular: (page: number = 1) => {
        return instance.get(`/movies/popular`, { params: { page } })
    },

    getTopRated: (page: number = 1) => {
        return instance.get(`/movies/top-rated`, { params: { page } })
    },

    getNowPlaying: (page: number = 1) => {
        return instance.get(`/movies/now-playing`, { params: { page, region: getRegion() } })
    },

    getUpcoming: (page: number = 1) => {
        return instance.get(`/movies/upcoming`, { params: { page, region: getRegion() } })
    },

    getMarvel: (page: number = 1) => {
        return instance.get(`/movies/marvel`, { params: { page } })
    },

    getNetflix: (page: number = 1) => {
        return instance.get(`/movies/netflix`, { params: { page } })
    },

    getByProvider: (providerKey: string, page: number = 1) => {
        return instance.get(`/movies/provider/${providerKey}`, { params: { page } })
    },

    search: (query: string, page: number = 1) => {
        return instance.get(`/movies/search`, { params: { query, page } })
    },

    getById: (id: number) => {
        return instance.get(`/movies/${id}`)
    },

    getRecommendations: (id: number, page: number = 1) => {
        return instance.get(`/movies/${id}/recommendations`, { params: { page } })
    },

    getCollection: (id: number) => {
        return instance.get(`/movies/collection/${id}`)
    }
}

export default moviesApi
